import { useState, useMemo, useCallback } from 'react';

export function useTransactionFilters({ monthTxns, incomeList, getGroup }) {
  const [filterSearch, setFilterSearch] = useState("");
  const [filterWho, setFilterWho] = useState("All");
  const [filterGroup, setFilterGroup] = useState("All");
  const [selectedTags, setSelectedTags] = useState([]);

  const filteredTxns = useMemo(() =>
    [...monthTxns]
      .filter(t => filterWho === "All" || t.who === filterWho)
      .filter(t => filterGroup === "All" || getGroup(t.category) === filterGroup || (filterGroup === "Income" && incomeList.includes(t.category)))
      .filter(t => !filterSearch || (t.description || "").toLowerCase().includes(filterSearch.toLowerCase()) || (t.category || "").toLowerCase().includes(filterSearch.toLowerCase()))
      .filter(t => selectedTags.length === 0 || selectedTags.every(tag => (t.tags || []).includes(tag)))
      .sort((a, b) => (b.date || "").localeCompare(a.date || "")),
    [monthTxns, filterWho, filterGroup, filterSearch, selectedTags, getGroup, incomeList]
  );

  const clearFilters = useCallback(() => {
    setFilterSearch("");
    setFilterWho("All");
    setFilterGroup("All");
    setSelectedTags([]);
  }, []);

  const hasActiveFilters = filterSearch || filterWho !== "All" || filterGroup !== "All" || selectedTags.length > 0;

  return {
    filterSearch, setFilterSearch,
    filterWho, setFilterWho,
    filterGroup, setFilterGroup,
    selectedTags, setSelectedTags,
    filteredTxns,
    clearFilters,
    hasActiveFilters,
  };
}
